import { render, staticRenderFns } from "./FiltersForBoardByReference.vue?vue&type=template&id=15d41a38&"
import script from "./FiltersForBoardByReference.vue?vue&type=script&lang=js&"
export * from "./FiltersForBoardByReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d41a38')) {
      api.createRecord('15d41a38', component.options)
    } else {
      api.reload('15d41a38', component.options)
    }
    module.hot.accept("./FiltersForBoardByReference.vue?vue&type=template&id=15d41a38&", function () {
      api.rerender('15d41a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/FiltersForBoardByReference.vue"
export default component.exports